import { Injectable } from '@angular/core';
import { SystemMessageStatus } from 'src/app/models/system-messages/system-message-types';
import { SystemMessageModel } from 'src/app/models/system-messages/system-message.model';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SystemMessageService {

    private messageSubject = new Subject<SystemMessageModel>();

    public showMessage(message: string, status: SystemMessageStatus) {
        let messageModel = new SystemMessageModel({
            message: message,
            status: status
        });
        this.messageSubject.next(messageModel);
    }

    get messages$() {
        return this.messageSubject.asObservable();
    }
}
